import { Grid } from '@mui/material';
import AppDownloadLinks, { Platforms } from 'components/AppDownloadLinks/AppDownloadLinks';
import { useTranslation } from 'react-i18next';
import { GTM, GTMElements, GTMLocations } from 'utils/analytics';

type Props = {
  linksLocation?: string;
  GTMLocation?: GTMLocations;
};

const AppStoreLinksMiniBanner = (props: Props) => {
  const { t } = useTranslation();
  const { linksLocation, GTMLocation } = props;

  // Track if app download links were clicked
  const onPlatformLinkClick = (platform: string, subLocation: string) => {
    GTM.elementClicked(platform === Platforms.ANDROID ? GTMElements.PLAYSTORE_LINK : GTMElements.APPSTORE_LINK, GTMLocation, {
      element_sub_location: subLocation,
    });
  };

  const gridProps = {
    item: true,
    md: 4,
    xs: 12,
  };

  return (
    <Grid {...gridProps} className="appstore-links-minibanner-grid">
      <div className="appstore-links-minibanner">
        <div className="appstore-links-minibanner_content">
          <div className="appstore-links-minibanner_content-inner">
            <h2>{t('components.appstore-links-minibanner.title')}</h2>
            <p>{t('components.appstore-links-minibanner.description')}</p>
            <div className="appstores-links-holder">
              <AppDownloadLinks onLinkClick={onPlatformLinkClick} linksLocation={linksLocation} />
            </div>
          </div>
        </div>
        <div className="appstore-links-minibanner_image">
          <img src={t('components.appstore-links-minibanner.hand-app-src')} alt="" className="appstore-links-minibanner-handapp" />
        </div>
      </div>
    </Grid>
  );
};

export default AppStoreLinksMiniBanner;
